import React, {useState, useEffect} from 'react';
import {FormControl, Select, MenuItem, CardContent} from '@material-ui/core';
import InfoBox from'./InfoBox';
import Map from './Map';
import Table from './Table';
import Linegraph from './Linegraph';
import {sortData, prettyPrintStat } from './utils';

//im trying to load circle illustrations but its not responding
import './App.css';
import 'leaflet/dist/leaflet.css'


function App() {
  
  //STATE = way to write a variable in react
  const[countries , setCountries] = useState([]);
  const[country , setCountry] = useState('Global Cases ☠');
  const[countryInfo, setCountryInfo] = useState({});
  const[tableData, setTableData] = useState([]);
  const[mapCenter, setMapCenter] = useState({lat:34.80746, lng:-40.4796});
  const[mapZoom, setMapZoom] = useState(3);
  const[mapCountries, setMapCountries] = useState([]);
  const[casesType, setCasesType] = useState('cases')
 
  //USEEFFECT = Runs a piece of code based on a given condition
  
  
  

  useEffect(() => {
    //send a requestto a server, wait for it, do somethign with the info
    const getCountriesData = async() => {
      await fetch('https://disease.sh/v3/covid-19/countries')
      .then((response) => response.json())
      .then((data) => {
        //returns a modified array based on a map function
        const countries = data.map((country) =>({
          name: country.country,
          value: country.countryInfo.iso2
        }));
        const sortedData = sortData(data);
        setTableData(sortedData);
        setMapCountries(data);
        setCountries(countries);
        
      })
    };
    getCountriesData();
   
  }, []);

  const onCountryChange = (event) => {
    const countryCode = event.target.value;
  
    const url = countryCode === "Global Cases ☠" ?
    "https://disease.sh/v3/covid-19/all"
    : `https://disease.sh/v3/covid-19/countries/${countryCode}`
     fetch(url)
    .then((response) => response.json())
    .then((data) => { 
    setCountry(countryCode);//updates the input field
      setCountryInfo(data); // stores the response of the countries information in a variable
    
      setMapCenter([data.countryInfo.lat, data.countryInfo.long]);
      setMapZoom(4);
      
      console.log(data);
    })
    
    console.log(countryCode);

  }

 useEffect(() => {
   fetch('https://disease.sh/v3/covid-19/all')
   .then((response) => response.json())
   .then((data) => {
     setCountryInfo(data);
   });
  }, [])

  useEffect(() => {
    fetch('https://disease.sh//v3/covid-19/vaccine/coverage/countries')
    .then((response) => response.json())
    .then((data) =>{
      setCountryInfo(data);
    });
  }, []);


  return (
    <div className="App">
      <div className='app-header'> 
        <h1>Epidemic Tracker App😷</h1>
        
        <FormControl className='app-dropdown'>
                <Select variant='outlined' 
                  onChange={onCountryChange}
                   value={country}/**the select attribute gives us the drop down effect  */>
                <MenuItem value={country}  className='app-dropdown--btn'>Global Cases ☠</MenuItem>
                  {countries.map((country) => (
                  <MenuItem value={country.value}>{country.name}</MenuItem>))}
                    </Select>
              </FormControl>


      </div>
      
      <div className='app-pane'>
          <div className='app-left-pane'>
            <CardContent>
                <h3>Live Cases By Country</h3>
                <Table countries = {tableData} />
                
            </CardContent>
          </div>

            <div className='app-middle-pane'>
                
                <div className='app-stats'>

                  <InfoBox
                    isRed 
                    active = {casesType === 'cases'}
                    className='info-pane'
                    onClick = {(e) => setCasesType('cases') }
                    title='Coronavirus Cases' 
                    cases = {prettyPrintStat(countryInfo.todayCases)}  
                    total = {prettyPrintStat(countryInfo.cases)}
                  />

                  <InfoBox 
                    active = {casesType === 'recovered'}
                    className='info-pane' 
                    onClick = {(e) => setCasesType("recovered") }
                    title=' Total Recovered' 
                    cases = {prettyPrintStat(countryInfo.todayRecovered)}  
                    total = {prettyPrintStat(countryInfo.recovered)}
                  />
                  <InfoBox 
                    isOrange
                    active = {casesType === 'deaths'}
                    className='info-pane' 
                    onClick = {(e) => setCasesType('deaths') }
                    title=' Total Deaths' 
                    cases = {prettyPrintStat(countryInfo.todayDeaths)}  
                    total = {prettyPrintStat(countryInfo.deaths)}
                  />
                  {/*<InfoBox 
                    className='info-pane' 
                    title='Total Vaccinated' 
                    cases = {prettyPrintStat(countryInfo.country)} 
                    total = {prettyPrintStat(countryInfo.timelines)}
                  />*/}
                  
                </div>
                <Map
                  casesType = {casesType}
                  center = {mapCenter}
                  zoom = {mapZoom}
                  countries = {mapCountries}
                />
                
            </div>

            <div className='app-right-pane'>
              <CardContent>

                <h4>Worldwide new {casesType} </h4>

                <Linegraph
                  casesType={casesType}
                />
              </CardContent>
            </div>
      </div>
      
      

    </div>
  );
}

export default App;
